/**
 * CTA_CLAY — the literal Clay the artist CTAs must render, bypassing the theme
 * ramp on purpose.
 *
 * Richie asked for "solid Clay #D2602E" on the artist CTA boxes. Coding that as
 * `color="brand.6"` looks right — `theme.ts`'s brand tuple has exactly
 * `#d2602e` at index 6 — but it is not what ships. The admin branding injector
 * regenerates the whole ramp from the stored `brand_primary_hex` via
 * `generatePalette`, which does NOT anchor its input at any index: it sweeps
 * ten fixed lightness targets and keeps the hue. So the stored `#D2602E` lands
 * nowhere in its own output, and `--mantine-color-brand-6` resolves to
 * `#a63c00` on prod — a dark rust, about one shade off the colour that was
 * asked for.
 *
 * That is a real drift and it is wider than these buttons: the whole live site
 * runs a shade darker than the tuple in `theme.ts`, so Storybook and production
 * disagree. Fixing it properly means anchoring the stored primary at index 6 in
 * `generatePalette`, which shifts every brand colour product-wide and is a
 * change to time deliberately rather than slip into a launch week. This
 * constant is the narrow fix taken in the meantime (2026-08-18): the eight CTAs
 * Richie named get the exact hex, and nothing else moves.
 *
 * ⚠️ Do NOT "tidy" these call sites back to `color="brand.6"`. That is the bug.
 * When `generatePalette` is fixed to anchor its input, `brand.6` and this
 * constant become the same colour and the call sites can go back — check that
 * first, then retire this file.
 *
 * Deliberately not read from a CSS token: the point is to be immune to the
 * injector. Label colour is still left to Mantine's `autoContrast`, so a light
 * brand override flips the label to ink rather than leaving white on white.
 */
export const CTA_CLAY = '#D2602E';
